import { Link, useLocation } from "react-router-dom";

const MenuItem = ({
  icon,
  text,
  to = "#",
  onClick = null,
  className = "",
  isSidebarOpen = true,
  hasArrow = true,
}) => {
  const location = useLocation();
  
  const handleClick = (e) => {
     if (to === "#") {
      e.preventDefault();
    } 
    else if (to === location.pathname && location.search && to !== "#") {
      e.preventDefault();
    }
      if (onClick) onClick(e);
  };

  return (
    <div className={`menu-item ${className} ${isSidebarOpen ? "" : "no-arrow"}`}>
      <Link
        to={to}
        className="d-flex align-items-center"
        onClick={handleClick}
      >
        <div className="icon-wrapper">
          <img className="icon" src={icon} alt={text} />
        </div>
        {isSidebarOpen && <span className="sidebar-menu-title">{text}</span>}
      </Link>
    </div>
  );
};
export default MenuItem;